import React from 'react';
import { Link } from 'react-router-dom';
import './components.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logo">
        event<span className="orange">find</span>
      </div>

      <div className="footer-links">
        <Link to="/privacy-policy">Privacy Policy</Link> | 
        <Link to="/terms-of-service">Terms of Service</Link> | 
        <Link to="/help">Help</Link>
      </div>

      <p className="footer-text">© 2025 Event Find. All rights reserved.</p>
    </footer>
  );
}
